const initialState = {
  bookingModal: {
    open: false,
    bookingData: {},
  },
  bookingsOpen: false,
  courseFilter: {
    tags: [],
    locations: [],
    startDates: [],
    showOnlyBookable: false,
  },
  occasionFilter: {
    locations: [],
    activities: [],
    weekdays: [],
    tags: [],
  },
  landingText: "",
  footerText: "",
  headerText: "",
  termsText: "",
  fetchText: true,
  menuOpen: window.innerWidth > 1024 ? true : false,
  paymentLoading: false,
  redirect: false,
  settingsOpen: false,
  toastOpen: false,
  toastText: "",
  toastType: "info",
};

export default initialState;
